export default {
  setUsers(state, payload) {
    state.users = payload.users;
    state.usersCount = payload.count;
    state.pageLimit = payload.pageLimit;
  },
  setUserInfo(state, payload) {
    state.userInfo = payload.userInfo;
  },
  setUserInfoProfile(state, payload) {
    state.userInfo.fullname = payload.fullname;
    state.userInfo.email = payload.email;
    state.userInfo.phone = payload.phone;
  },
  setUserInfoType(state, payload) {
    state.userInfo.type = payload;
  },
  setUserInfoSkills(state, payload) {
    state.userInfo.skills = payload;
  },
  setUserStatus(state, payload) {
    state.userInfo.statusID = payload;
  },
  setDomainSkills(state, payload) {
    state.domainSkills = payload;
  },
  setDialOutNum(state, payload) {
    state.dialoutNum = payload;
  },
  setUserLoginStatus(state, payload) {
    state.userLoginStatus = payload;
  },
  setDomainRanges(state, payload) {
    state.domainRanges = payload;
  },
  setDomainUsers(state, payload) {
    state.domainUsers = payload;
  },
  setUserInfoValidty(state, payload) {
    state.userInfo.isValid = payload;
  },

  setSkillInfo(state, payload) {
    state.skillInfo = payload;
  },
  setSchedules(state, payload) {
    state.schedules = payload;
  },
  setWaitClasses(state, payload) {
    state.waitClasses = payload;
  },
  setWelcomeMsg(state, payload) {
    state.welcomeMessage = payload;
  },
  setDomains(state, payload) {
    state.allDomains = payload;
  },
  setDomainInfo(state, payload) {
    state.domainInfo = payload;
  },
  setDomainsNames(state, payload) {
    state.domainsNames = payload;
  },
  setdomainsShortCodes(state, payload) {
    state.domainsShortCodes = payload;
  },
  setDomainsRanges(state, payload) {
    state.domainsRanges = payload;
  },
  setDomainNonDefaultPermissions(state, payload) {
    state.domainsNotDefaultPermissions = payload;
  },
  setDefaultDominUserPermissions(state, payload) {
    state.domainDefaultUserPermissions = payload;
  },
  setDefaultDomainPhoneInfo(state, payload) {
    state.domainDefaultPhoneInfo = payload;
  },
  setAllDomainsSkills(state, payload) {
    state.domainsSkills = payload;
  },
  setDomainUsernames(state, payload) {
    state.domainUsernames = payload;
  },
  setIvrRating(state, payload) {
    state.ivrRating = payload;
  },
  setOmniRating(state, payload) {
    state.omniRating = payload;
  },
  setCallReasons(state, payload) {
    // console.log("My payload reason", payload);
    state.callReasons = payload;
  },
  setKpis(state, payload) {
    state.kpis = payload;
  },
  setCSATQuestions(state, payload) {
    state.csatQuestions = payload;
  },
  setStatusReasons(state, payload) {
    state.statusReasons = payload;
  },
  setUserLimits(state, payload) {
    state.userLimits = { ...state.userLimits, ...payload };
  },
};
